import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { Outlet } from "react-router-dom";
import useSWR from "swr";
import Header from "./Header";
import BottomTabs from "./BottomTabs";

function AppShell({ title }) {
  // 본인 프로필을 항상 한 번 보장 — RequestDetailPage 등이 localStorage.user 를 권한 판단에 사용
  const { data: me } = useSWR("/manager/change-request/me");
  useEffect(() => {
    if (me) localStorage.setItem("user", JSON.stringify(me));
  }, [me]);

  return (
    <Wrapper>
      <Header title={title} />
      <Body>
        <Outlet />
      </Body>
      <BottomTabs />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f6f7f9;
`;
const Body = styled.main`
  flex: 1;
  padding: 16px;
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
`;

export default AppShell;
